/** @module Auth0BetaOptInFeatureBase */
/* eslint-disable import/extensions */
import Auth0Constants from '../auth0-constants.mjs';
import Auth0UtilsBrowser from '../auth0-utils-browser.mjs';
import Auth0UserSessionHelper from '../auth0-session-helper.mjs';

/**
 * @abstract
 */
class Auth0BetaOptInFeatureBase {
  constructor(options) {
    this._featureId = options.featureId; // needs to match the LD flag's ID (if using LD)
    console.log(`Auth0BetaOptInFeatureBase init for flag "${this._featureId}"`);
  }

  get featureId() {
    return this._featureId;
  }

  _init() {
    this._restoreStateFromDisk();
    this._validate();
    // implement custom init in derived classes
  }

  _validate() {
    if (!this._featureId) {
      throw new Error('All opt in features must be instantiated with a valid `featureId` prop');
    }
    // implement custom validation in derived classes
  }

  optIn() {
    // implement custom opt in behavior in derived classes
  }

  optOut() {
    // implement custom opt out behavior in derived classes
  }

  async isOptedIn() {
    // implement in derived classes
  }

  _restoreStateFromDisk() {
    // implement in derived classes (allows each type to manage their own opt in data)
  }

  get supportsUserOptIn() {
    return false;
  }

  refresh() {
    // if persisted state updated externally, ask this object to update itself
    this._restoreStateFromDisk();
  }

  _buildUserContextFromAuthState() {
    this._actualUserContextData = {
      userId: Auth0UserSessionHelper.userId,
      username: Auth0UserSessionHelper.userUserName,
      sellerId: Auth0UserSessionHelper.userSellerId,
    };
  }

  _saveOptInOptionsState(featureStateObject = {}) {
    const modifiedOptInData = this._allPersistedBetaOptInData;
    modifiedOptInData[this._featureId] = featureStateObject;

    Auth0UtilsBrowser.setOption({
      cookieName: Auth0Constants.AUTH0_BETA_OPT_IN_KEY,
      expiryDay: 365,
      stringify: true,
      value: modifiedOptInData,
    });
  }

  get _persistedBetaOptInData() {
    return this._allPersistedBetaOptInData[this._featureId] ?? {};
  }

  get _allPersistedBetaOptInData() {
    const optInData = Auth0UtilsBrowser.getOption({ keyName: Auth0Constants.AUTH0_BETA_OPT_IN_KEY }, false, true);
    if (!optInData) return {};
    return optInData;
  }
}

export default Auth0BetaOptInFeatureBase;
